import FilesCounterTitle from "../../Reusable/FilesCounterTitle.js";
import RemoveAllFilesComponent from "../../Reusable/RemoveAllFilesComponent.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import styles from "./styles.module.scss";
import { useUser } from "contexts/userContext/userContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon";
import { LinkToNewTab } from "components/Elements/Link/Link";

const limitsState = {
  pro: "up-to-general",
  anonymous: "up-to-free",
  free: "up-to-free",
};

export const UploaderPreviewControl = () => {
  const { getUploading } = useUploader();
  const { getUserData, isLoggedIn } = useUser();
  const { getTextByKey } = useContent();

  const limitText = limitsState[getUserData().userSubscriberSystemName];
  const showLimits = !isLoggedIn() || limitText;

  return (
    <div className={styles.wrap}>
      {!getUploading() ? (
        <div className={styles.files}>
          <FilesCounterTitle />
          <RemoveAllFilesComponent />
        </div>
      ) : null}
      {showLimits ? (
        <div className={styles.limit}>
          <span className={styles.upTo}>
            {getTextByKey(!isLoggedIn() ? limitsState.anonymous : limitText)}
          </span>
          <Icon name="jm-marketing-icon" iconClass={styles.icon} />
          <LinkToNewTab
            ariaLabel="link to plans page"
            style={{}}
            page="plans"
            classes={styles.link}
            target="_blank"
          >
            {getTextByKey("increaser-limit")}
          </LinkToNewTab>
        </div>
      ) : null}
    </div>
  );
};
